import { render } from "./survey-rating.component.vue?vue&type=template&id=a60eb3fa&ts=true"
import script from "./survey-rating.component.vue?vue&type=script&lang=ts"
export * from "./survey-rating.component.vue?vue&type=script&lang=ts"

import "./survey-rating.component.vue?vue&type=style&index=0&id=a60eb3fa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__